import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, ref, Ref } from 'vue';
import { useRoute } from 'vue-router/composables';
import { debounce } from 'lodash-es';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  Row,
  HeadingDisplay,
  BaseText,
  ListDisplay,
  SkeletonLoader,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { InputMoney } from '@/modules/transaction/components/InputMoney';

import { getStatus, getHelperText, getDetails } from './helpers';

import {
  getNetValue,
  IWithdrawDetails
} from '@/modules/transaction/services/withdraw-by-portfolio';
import { ModalAvailableForRedemption } from './components';


export default /*#__PURE__*/_defineComponent({
  __name: 'WithdrawStep',
  setup(__props) {

const route = useRoute();

const getWithdrawReview = inject('fetchWithdrawReview', async () => ({}));
const getBankList = inject('fetchBankList', async () => ({}));
const updateAmount = inject('updateAmount', (value: number) => ({
  value
}));

const withdrawDetails = inject('withdrawDetails') as Ref<IWithdrawDetails>;
const amountValue = ref(0);
const netValue = ref('R$ 0,00');
const isLoading = ref(false);
const isFetchingNetValue = ref(false);
const isButtonDisabled = ref(false);
const modalIsOpen = ref(false);

const status = computed(() => {
  return getStatus(amountValue.value, withdrawDetails.value);
});

const helperText = computed(() => {
  return getHelperText(amountValue.value, withdrawDetails.value);
});

const listDetails = computed(() => {
  return getDetails(
    withdrawDetails.value,
    netValue.value,
    isFetchingNetValue.value
  );
});

const isDisabled = computed(() => {
  return (
    amountValue.value <= 0 || status.value === 'error' || isButtonDisabled.value
  );
});

const portfolioId = computed(() => {
  return route.params.id as string;
});

function handleBlur() {
  if (amountValue.value < withdrawDetails.value.minimumRedemption.value) {
    netValue.value = 'R$ 0,00';

    return;
  }

  fetchNetValue(amountValue.value);
}

const debounceChangeValue = debounce(async data => {
  onChangeValue(data);
}, 500);

function onChangeValue(data: { value: number; increment: boolean }) {
  amountValue.value = data.value;
  netValue.value = 'R$ 0,00';
  isButtonDisabled.value = true;

  if (
    data.increment &&
    amountValue.value >= withdrawDetails.value.minimumRedemption.value
  ) {
    fetchNetValue(data.value);
  }
}

function openModal() {
  modalIsOpen.value = true;
}

function closeModal() {
  modalIsOpen.value = false;
}

function handleClick() {
  updateAmount(amountValue.value);

  if (withdrawDetails.value.canRedeemDirectly) {
    return fetchBankList();
  }

  fetchReview();
}

async function fetchBankList() {
  try {
    isLoading.value = true;

    await getBankList();
  } finally {
    isLoading.value = false;
  }
}

async function fetchReview() {
  try {
    isLoading.value = true;

    await getWithdrawReview();
  } finally {
    isLoading.value = false;
  }
}

async function fetchNetValue(amount: number) {
  isFetchingNetValue.value = true;

  try {
    const data = await getNetValue(portfolioId.value, amount);

    netValue.value = data.netValue.formatted;
  } catch (e) {
    console.error(e);
  } finally {
    isFetchingNetValue.value = false;
    isButtonDisabled.value = false;
  }
}

return { __sfc: true,route, getWithdrawReview, getBankList, updateAmount, withdrawDetails, amountValue, netValue, isLoading, isFetchingNetValue, isButtonDisabled, modalIsOpen, status, helperText, listDetails, isDisabled, portfolioId, handleBlur, debounceChangeValue, onChangeValue, openModal, closeModal, handleClick, fetchBankList, fetchReview, fetchNetValue, NebraskaColors, Row, HeadingDisplay, BaseText, ListDisplay, SkeletonLoader, ButtonContainer, ButtonPrimary, InputMoney, ModalAvailableForRedemption }
}

})